import { FC, useState } from 'react';
import styles from './PageToc.module.scss';

export interface TocItem {
  id: string;
  label: string;
}

export interface PageTocProps {
  items: TocItem[];
  activeId?: string;
  onItemClick?: (id: string) => void;
  description?: string;
}

export const PageToc: FC<PageTocProps> = ({
  items,
  activeId: controlledActiveId,
  onItemClick,
  description = 'Use the links to jump through a long information page without losing the original content hierarchy.',
}) => {
  const [internalActiveId, setInternalActiveId] = useState<string>(
    items.length > 0 ? items[0].id : ''
  );

  const currentActiveId = controlledActiveId !== undefined ? controlledActiveId : internalActiveId;

  const handleClick = (id: string) => {
    setInternalActiveId(id);
    if (onItemClick) {
      onItemClick(id);
    }
  };

  return (
    <nav className={styles.tocWrapper} aria-label="On this page navigation">
      <div className={styles.title}>ON THIS PAGE</div>
      <ul className={styles.navList}>
        {items.map((item) => {
          const isActive = item.id === currentActiveId;
          return (
            <li key={item.id} className={styles.navItem}>
              <a
                href={`#${item.id}`}
                className={`${styles.navLink} ${isActive ? styles.active : ''}`}
                aria-current={isActive ? 'true' : undefined}
                onClick={() => handleClick(item.id)}
              >
                {item.label}
              </a>
            </li>
          );
        })}
      </ul>
      {description && <p className={styles.description}>{description}</p>}
    </nav>
  );
};
